import { Flex, Text } from "@chakra-ui/react"
import { RootState, useAppSelector } from "../../../store";
import { formatDate } from "../../../helpers/formatDate";

export const HistoryVacancyBlock = () => {

    const { currentVacancy } = useAppSelector(
        (state: RootState) => state.vacancy
    );

    return (
        <Flex gap="24px" flexDirection="column" borderLeft="1px solid grey" maxH="70vh" overflowY="auto" paddingLeft="36px">
            <Text fontWeight={500}>История взаимодействия</Text>
            <Flex flexDirection="column" gap="16px">
                {currentVacancy?.activities.map((activity) => (
                    <Flex flexDirection="column" borderBottom="1px solid grey" paddingBottom="16px">
                        <Text fontWeight={600} marginBottom="8px">{formatDate(activity.created_at, true)}</Text>
                        <Text>{activity.action}</Text>
                    </Flex>
                ))}
            </Flex>
        </Flex>
    )
}